<template>
  <v-row>
    <v-col cols="12" md="4">
      <AdPolicyCard
        title="Zakázané produkty a služby"
        icon="fad fa-times-octagon"
      >
        <p>
          Na Facebooku <strong>nesmíte propagovat</strong> (nejedná se o
          kompletní seznam):
        </p>
        <p>
          zbraně, cigarety, léky, produkty a služby pouze pro dospělé,
          seznamovací služby, úvěry a půjčky.
        </p>
      </AdPolicyCard>
    </v-col>
    <v-col cols="12" md="4">
      <AdPolicyCard title="Good vibrations" icon="fad fa-sad-tear">
        <p>
          <strong>Nevyvolávejte negativní pocity</strong>. Chcete zhubnout? Máte
          deprese? Vyhněte se „vy“, „ty“, mluvte o sobě nebo o „lidech“.
        </p>
      </AdPolicyCard>
    </v-col>
    <v-col cols="12" md="4">
      <AdPolicyCard title="Opt-in / prodejní stránka" icon="fad fa-window-alt">
        <p>
          <strong>Vše</strong>, co musí splňovat vaše propagace na Facebooku,
          <strong> musí splňovat také stránka</strong>, na kterou lidi vedete!
        </p>
        <p>
          Pozor na „zakázaná“ slova i obsah na přistávací stránce.
        </p>
      </AdPolicyCard>
    </v-col>
    <v-col cols="12" md="4">
      <AdPolicyCard title="Tvrzení" icon="fad fa-theater-masks">
        <p>
          <strong
            >Vyhněte se tvrzením, která nejsou platná vždy a pro všechny</strong
          >. Zhubněte 8 kg za měsíc. Naučte se, jak vydělat milión za rok.
          Neslibujte čtenáři, mluvte o výsledcích klientů.
        </p>
      </AdPolicyCard>
    </v-col>
    <v-col cols="12" md="4">
      <AdPolicyCard title="Obsah pro dospělé" icon="fad fa-book-heart">
        <p>
          <strong>Sexualita a nahota je zakázaná</strong>. Facebook zakáže
          každou reklamu, která bude obsahuvat sexuálně nabitá slova,
          vulgarismy, ale i obrázky s obnaženými těly.
        </p>
      </AdPolicyCard>
    </v-col>
    <v-col cols="12" md="4">
      <AdPolicyCard title="Pravidla se mění" icon="fad fa-file-signature">
        <p>
          Průběžně (alespoň 1x měsíčně) kontrolujte
          <a
            class="link link-underline"
            href="https://facebook.com/policies/ads"
          >
            pravidla a zásady na Facebooku pro inzerci </a
          >.
        </p>
      </AdPolicyCard>
    </v-col>
  </v-row>
</template>

<script>
import AdPolicyCard from "./AdPolicyCard.vue"

export default {
  components: {
    AdPolicyCard,
  },
}
</script>
